import React from 'react'
import { Button } from 'semantic-ui-react'
import styled from 'styled-components';


export default styled(Button)`
  &.ui.button {
    font-size: 14px;
    padding: 1.215em 1.5em;
  }
`;